import { getAIMatchNotificationSettings } from 'RestAPIs/ai-match';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import { AdminSettings } from 'components/types';
import { UseQueryResult, useQuery } from 'react-query';

const useGetAIMatchSettings = (options?: {
  [key: string]: any;
}): UseQueryResult<AdminSettings> => {
  return useQuery({
    queryKey: ['ai-match-settings'],
    queryFn: async () => {
      const { data } = await getAIMatchNotificationSettings();

      return data?.[0];
    },
    onError: () => {
      showErrorSnackbar();
    },
    ...(options || {})
  });
};

export default useGetAIMatchSettings;
